<template>
  <article class="container">
    <section class="content mycheck_wrap">
      <div class="content_inner">
        <h1 class="logo_mc">
          <img src="~@/assets/images/common/logo_mc.png" alt="multicampus">
        </h1>
        <div class="section_header mycheck_header center bg_mytime" data-effect-slide="scroll">
          <p class="text">출결가능한 시간이 아닙니다.</p>
          <span class="disc">수업 시작 {{ time }}분 전부터 가능합니다.</span>
          <div data-effect-svg="mytime">
            <div class="clock" />
            <img src="~@/assets/images/check/bg_mytime_blob.svg" width="200" height="200" alt="">
            <img src="~@/assets/images/check/bg_mytime.svg" width="200" height="200" alt="">
          </div>
        </div>
        <div class="section_content">
          <div class="check_my-info" data-effect-slide="scroll" >
            <p class="info_title">{{ corsInfo.corsNm }}</p>
            <ul class="info_detail">
              <li v-if="corsInfo.eduStartDtm" class="info_schedule"><span class="blind">학습기간</span>
                <span class="txt">{{ corsInfo.eduStartDtm }} ~ {{ corsInfo.eduEndDtm }}</span>
              </li>
              <li v-if="corsTimeShow && corsInfo.eduStartTmHm" class="info_time"><span class="blind">학습시간</span>
                <span class="txt">{{ corsInfo.eduStartTmHm }} ~ {{ corsInfo.eduEndTmHm }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  </article>
</template>

<script>
import MotionEffects from '@/assets/js/MotionEffects'

export default {
  name: 'AttendTimeCheck',
  metaInfo () {
    return {
      title: '멀티캠퍼스 :: QR출석체크 시간체크'
    }
  },
  components: {
  },
  mixins: [MotionEffects],
  props: {
    param: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      time: '90',
      params: null,
      corsInfo: {},
      corsTimeShow: false
    }
  },
  created () {
    this.initializeParams()
  },
  beforeDestroy () {
    sessionStorage.removeItem('corsParams')
  },
  mounted () {
    this.selectQrCorsBasic()
  },
  methods: {
    initializeParams () {
      const storedParams = JSON.parse(sessionStorage.getItem('corsParams'))
      if (this.$route.params.corsParams) { // 출석 체크 후
        this.params = {...this.$route.params.corsParams}
        sessionStorage.setItem('corsParams', JSON.stringify(this.params))
      }

      if (this.$route.query.atdncType ) { // 출석 체크 후
        this.params = storedParams
        this.corsTimeShow = true
      }

      if (this.$route.params.corsInfo) { // 출석 체크 후
        this.corsInfo = { ...this.$route.params.corsInfo }
        this.corsTimeShow = true
      }

      if (Object.keys(this.$props.param).length > 0 && this.$props.param.corsTimeChk === 'N' ) {
        this.corsTimeShow = true
      }

      if (!this.params) {
        this.setParamsFromRouteQuery()
      }
    },
    setParamsFromRouteQuery () {
      const param = {
        eduGrpCd: this.$route.query.eduGrpCd || 'CUS0001',
        corsCd: this.$route.query.corsCd,
        corsYr: this.$route.query.corsYr,
        corsDgrCd: this.$route.query.corsDgrCd,
        clssDgr: this.$route.query.clssDgr || '1',
        langCd: this.getUserLangCd()
      }
      this.params = { ...param }
    },
    selectQrCorsBasic () {
      let params = { ...this.params }
      this.$http.b2c.selectQrCorsBasic(this, params).then(result => {
        if (result.data.status === 'OK') {
          this.corsInfo = { ...result.data.data.corsInfo }
          if (this.$route.params.corsTimeChk === 'N') {
            this.corsTimeShow = true
          }
        }
      })
    }
  }
}
</script>

<style scoped>
.container {padding-top:0;}
</style>



// WEBPACK FOOTER //
// src/components/pages/nrw/attend/AttendTimeCheck.vue